import React, { useMemo } from "react";
import { IoMdArrowForward } from "react-icons/io";
import OrderStatus from "../../../../components/order/OrderStatus";

function BookingConfirmationRoutes({ data }) {
  const bookedDirections = useMemo(() => {
    const flights = data?.flightBooking?.flights || [];
    const directionLib = {};
    for (const flight of flights) {
      if (directionLib[flight?.segment]) {
        directionLib[flight?.segment].push(flight);
      } else {
        directionLib[flight?.segment] = [flight];
      }
    }
    return Object.values(directionLib);
  }, [data?.flightBooking]);

  const routeType = useMemo(() => {
    const destinations = data?.flightBooking?.destinations || [];
    if (destinations?.length === 1) return "One way";
    if (destinations?.length === 2) {
      if (
        destinations[0]?.from === destinations[1]?.to &&
        destinations[0]?.to === destinations[1]?.from
      ) {
        return "Round trip";
      }
    }
    return "Multi city";
  }, [data]);

  const cities = useMemo(() => {
    const directions = bookedDirections || [];
    switch (routeType) {
      case "Round trip": {
        const direction = directions[0];
        const firstSeg = direction[0];
        const lastSeg = direction[direction?.length - 1];
        return [firstSeg?.departureLocationName, lastSeg?.arrivalLocationName];
      }
      default:
        return directions?.flatMap((direction, directionIndex) => {
          const firstSeg = direction[0];
          const items = [firstSeg?.departureLocationName];
          if (directionIndex === directions?.length - 1) {
            const lastSeg = direction[direction?.length - 1];
            items.push(lastSeg?.arrivalLocationName);
          }
          return items;
        });
    }
  }, [data, routeType, bookedDirections]);

  const displayableItems = useMemo(() => {
    const items = [];
    for (let i = 0; i < cities?.length; i++) {
      const city = cities[i];
      items.push({ type: "city", city });
      if (i < cities?.length - 1) items.push({ type: "arrow" });
    }
    return items;
  }, [cities]);

  // console.log({ data });

  return (
    <div className="flex gap-4 w-full lg:w-fit items-center justify-between">
      <div className="text-primary1 text-sm font-semibold bg-primary1/10 rounded-md w-28 hidden lg:flex items-center justify-center py-1">
        {routeType}
      </div>
      <div className="flex gap-2 flex-wrap justify-end items-center -mt-3 lg:mt-0">
        {displayableItems?.map((item, itemIndex) =>
          item?.type === "city" ? (
            <div key={itemIndex}>
              <span className="font-bold text-lg">{item?.city}</span>
            </div>
          ) : (
            <div key={itemIndex} className="text-lg">
              <IoMdArrowForward />
            </div>
          )
        )}
      </div>
      <div className="flex lg:hidden">
        <OrderStatus mobile value={data?.flightBooking?.status} />
      </div>
    </div>
  );
}

export default BookingConfirmationRoutes;
